import { volateqApi } from "../../services/volateq-api/volateq-api";
import { BaseAuthComponent } from "./base-auth-component";

export abstract class BaseAuthOnlineComponent extends BaseAuthComponent {
  protected volateqApi = volateqApi;
}
